import axios from 'axios'

export default {
  namespaced: true,
  state: () => ({
    token: localStorage.getItem('auth_token') || null,
    user: localStorage.getItem('user_data') ? JSON.parse(localStorage.getItem('user_data')) :  null
  }),
  mutations: {
    SET_USER(state, payload) {
      state.token = payload.token
      state.user = payload.user
      localStorage.setItem('auth_token', payload.token)
      localStorage.setItem('user_data', JSON.stringify(payload.user))
    },
    LOGOUT(state) {
      state.token = null
      state.user = null
      localStorage.removeItem('auth_token')
      localStorage.removeItem('user_data')
    }
  },
  actions: {
    set_user({ commit }, {token, user}) {
        commit('SET_USER', { token, user })
    },  
    async login({ commit }, {method, data}) {
        if(method === 'iin'){
            try{
                const response = await axios.post('/V1/auth/credentials-login', data)
                if(response.data.data.access_token){
                    const { access_token, user } = response.data.data
                    commit('SET_USER', { token: access_token, user })
                    return {success: true}
                }   
            }catch(error){
                return {success: false, error: error}
            }
        }else if(method === 'ecp'){
            try{
                const response = await axios.post('/V1/auth/ecp-login', data)
                if(response.data.data.access_token){
                    const { access_token, user } = response.data.data
                    commit('SET_USER', { token: access_token, user })
                    return {success: true}
                }else{
                    return {success: false}
                }
            }catch(error){
                return {success: false, error: error}
            }
        }
    },
    async logout({ commit }) {
      try{
        await axios.post('/V1/auth/logout')
        commit('LOGOUT')
      }catch(error){
        console.log(error);
      }
    },
    logoutTokenUnactive({commit}){
      console.log(commit);
      
      commit('LOGOUT');
    }
  },
  getters: {
    isAuthenticated: state => !!state.token ,
    getUser: state => state.user
  }
}
